import { Injectable } from '@angular/core';
import moment from 'moment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsChartService {

  constructor() { }

  getReportTimeOptions() {
    return [{
      duration: '3D',
      step: 'day',
      text: 'Last 3 days'
    }, {
      duration: '7D',
      step: 'day',
      text: 'Last 7 days'
    }, {
      duration: '1M',
      step: 'day',
      text: 'Last month'
    }, {
      duration: '3M',
      step: 'day',
      text: 'Last 3 months'
    }];
  }

  getStartAndEndTime(step, duration) {
    let endTime, startTime;
    if (step === 'month') {
      endTime = moment().utc().add(moment.duration('P1M')).startOf('month');
      startTime = moment(endTime).subtract(moment.duration('P' + duration));
    }
    if (step === 'day') {
      endTime = moment().utc().add(moment.duration('P1D')).startOf('day');
      startTime = moment(endTime).subtract(moment.duration('P' + duration));
    }
    if (step === 'hour') {
      endTime = moment().utc().add(1, 'hour').set({
        minute: 0,
        second: 0
      });
      startTime = moment(endTime).subtract(moment.duration('P' + duration));
    }
    return ({ start: startTime, end: endTime });
  }

  generateX(startTime, endTime, step) {
    const stillUtcStart = moment.utc(startTime.set({
      minute: 0,
      second: 0
    })).toDate();
    const stillUtcEnd = moment.utc(endTime.set({
      minute: 0,
      second: 0
    })).toDate();
    const start = moment(stillUtcStart).local();
    const end = moment(stillUtcEnd).local();
    const timeSeries = [];
    for (; end.diff(start); start.add(1, step)) {
      timeSeries.push(start.format('DD/MM/YYYY'));
    }
    return timeSeries;
  }

  getLineChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0
        }
      },
      legend: {
        position: 'right',
        labels: {
          boxWidth: 23,
          padding: 20,
          fontSize: 16,
          fontFamily: '"Nunito Sans", serif',
          fontColor: '#465b66'
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            precision: 0,
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66'
          },
          scaleLabel: {
            display: true,
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66',
            labelString: 'GOAL'
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66',
            labelString: 'TIMELINE'
          },
          ticks: {
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66',
          }
        }]
      },
      tooltips: {
        enabled: true,
        mode: 'label',
        titleFontStyle: 'normal',
        titleFontFamily: '"Nunito Sans", serif',
        bodyFontFamily: '"Nunito Sans", serif',
        footerFontFamily: '"Nunito Sans", serif',
        footerFontStyle: 'normal',
        xPadding: 12,
        yPadding: 12,
        callbacks: {
          title: function (tooltipItems, data) {
            const idx = tooltipItems[0].index;
            return data.labels[idx];
          }
        }
      }
    };
  }

  getBarChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0
        }
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            precision: 0,
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66'
          },
          scaleLabel: {
            display: true,
            labelString: 'CLICKS',
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66',
          },
          gridLines: {
            display: false
          }
        }],
        xAxes: [{
          ticks: {
            fontFamily: '"Nunito Sans", serif',
            fontColor: '#465b66',
            callback: value => _.truncate(value, { length: 10 })
          },
          maxBarThickness: 20,
          gridLines: {
            display: false
          }
        }]
      },
      tooltips: {
        enabled: true,
        mode: 'label',
        titleFontStyle: 'normal',
        titleFontFamily: '"Nunito Sans", serif',
        bodyFontFamily: '"Nunito Sans", serif',
        footerFontFamily: '"Nunito Sans", serif',
        footerFontStyle: 'normal',
        xPadding: 12,
        yPadding: 12,
        callbacks: {
          title: function (tooltipItems, data) {
            const idx = tooltipItems[0].index;
            return data.labels[idx];
          }
        }
      }
    };
  }

  getLineChartColors() {
    return [
      {
        backgroundColor: 'rgba(48, 214, 197, 1)',
        borderColor: 'rgba(48, 214, 197, 1)',
        pointBackgroundColor: 'rgba(48, 214, 197, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(48, 214, 197, 0.8)'
      },
      {
        backgroundColor: 'rgba(129, 187, 228, 1)',
        borderColor: 'rgba(129, 187, 228, 1)',
        pointBackgroundColor: 'rgba(129, 187, 228, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(129, 187, 228, 1)'
      },
      {
        backgroundColor: 'rgba(134, 155, 204, 1)',
        borderColor: 'rgba(134, 155, 204, 1)',
        pointBackgroundColor: 'rgba(134, 155, 204, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(134, 155, 204, 0.8)'
      },
      {
        backgroundColor: 'rgba(214, 157, 206, 1)',
        borderColor: 'rgba(214, 157, 206, 1)',
        pointBackgroundColor: 'rgba(214, 157, 206, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(214, 157, 206, 0.8)'
      },
      {
        backgroundColor: 'rgba(189, 120, 162, 1)',
        borderColor: 'rgba(189, 120, 162, 1)',
        pointBackgroundColor: 'rgba(189, 120, 162, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(189, 120, 162, 0.8)'
      },
      {
        backgroundColor: 'rgba(198, 101, 97, 1)',
        borderColor: 'rgba(198, 101, 97, 1)',
        pointBackgroundColor: 'rgba(198, 101, 97, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(198, 101, 97, 0.8)'
      },
      {
        backgroundColor: 'rgba(232, 120, 129, 1)',
        borderColor: 'rgba(232, 120, 129, 1)',
        pointBackgroundColor: 'rgba(232, 120, 129, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(232, 120, 129, 0.8)'
      },
      {
        backgroundColor: 'rgba(242, 173, 71, 1)',
        borderColor: 'rgba(242, 173, 71, 1)',
        pointBackgroundColor: 'rgba(242, 173, 71, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(242, 173, 71, 0.8)'
      },
      {
        backgroundColor: 'rgba(255, 213, 79, 1)',
        borderColor: 'rgba(255, 213, 79, 1)',
        pointBackgroundColor: 'rgba(255, 213, 79, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(255, 213, 79, 0.8)'
      },
      {
        backgroundColor: 'rgba(220, 220, 220, 1)',
        borderColor: 'rgba(220, 220, 220, 1)',
        pointBackgroundColor: 'rgba(220, 220, 220, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(220, 220, 220, 0.8)'
      },
      {
        borderColor: 'rgba(160, 160, 160, 1)',
      }
    ];
  }
}
